function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19",
  height: "16",
  viewBox: "0 0 19 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19 1.889c-.699.32-1.45.536-2.239.634A4.019 4.019 0 0018.475.294 7.653 7.653 0 0116 1.272 3.835 3.835 0 0013.155 0c-2.153 0-3.899 1.803-3.899 4.028 0 .315.035.623.101.917-3.24-.167-6.112-1.771-8.034-4.208a4.111 4.111 0 00-.528 2.025c0 1.397.688 2.63 1.734 3.352a3.788 3.788 0 01-1.765-.503v.05c0 1.952 1.343 3.58 3.126 3.95a3.785 3.785 0 01-1.76.069c.496 1.6 1.935 2.764 3.641 2.797A7.662 7.662 0 010 14.145a10.777 10.777 0 005.975 1.81c7.17 0 11.091-6.138 11.091-11.46 0-.175-.004-.349-.011-.522A8.068 8.068 0 0019 1.89z",
  fill: "currentColor",
  fillRule: "evenodd"
})));